import BoardUtils from '../Game/BoardUtils';
import { ITileType } from './TileSet';

export default class BoardObject {
    public layer: number;
    public position: [number, number, number];
    public tileType: ITileType;
    public blockPositions: string[]; // store ids of blocking
    public supportPositions: string[]; // ids of pieces below, 'floor' if already on bottom layer (magnet will pull pieces and make others drop)
    public conditions: string[]; // frozen, locked, etc
    public locId: string;
    public boardId: string;
    public tileSprite: string;
    public matched: boolean;
    [key: string]: string | string[] | number | number[] | ITileType | boolean; // also had PIXI.Sprite (prob for tileSprite) but pixi can't be here for testing

    constructor(position: [number, number, number], id: string) {
        this.layer = position[0];
        this.position = position;
        this.blockPositions = [];
        this.boardId = id;
        this.locId = BoardUtils.formatBoardId(position);
        this.conditions = [];
        this.supportPositions = [];
        this.tileSprite = null;
        this.tileType = { suit: 'special', value: 0 };
        this.matched = false;
    }
}
